import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'libs/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    // Sélecteur de contexte (Sprint 3) — pas de contrainte de rôle : c'est
    // justement ce qui n'est pas encore choisi à ce stade. AuthGuard exige
    // seulement une identité connectée (route.data.roles absent).
    path: 'context-selector',
    loadChildren: () => import('./pages/context-selector/context-selector.module').then((m) => m.ContextSelectorPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'manager/home',
    loadChildren: () => import('./pages/manager/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
    data: { roles: ['manager'] },
  },
  {
    path: 'tutor/home',
    loadChildren: () => import('./pages/tutor/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
    data: { roles: ['tutor'] },
  },
  {
    path: 'tutor/home/:trainingId',
    loadChildren: () => import('./pages/tutor/training/training.module').then((m) => m.TrainingPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['tutor'] },
  },
  {
    path: 'tutor/documents/:trainingId',
    loadChildren: () => import('./pages/tutor/documents/documents.module').then((m) => m.DocumentsPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['tutor'] },
  },
  {
    path: ':viewer/:trainingId/profile/:role/:id',
    loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: ':viewer/:trainingId/questionnaire/:type/:role/:id',
    loadChildren: () => import('./pages/questionnaire/questionnaire.module').then((m) => m.QuestionnairePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: ':viewer/:trainingId/questionnaire/:type/:role/:id/:tutorId',
    loadChildren: () => import('./pages/questionnaire/questionnaire.module').then((m) => m.QuestionnairePageModule),
    canActivate: [AuthGuard],
  },
  {
    // Route for viewing manager evaluations (OF) - read-only for apprentices and tutors
    path: ':viewer/:trainingId/questionnaire/manager-evaluation/:role/:id',
    loadChildren: () => import('./pages/questionnaire/questionnaire.module').then((m) => m.QuestionnairePageModule),
    canActivate: [AuthGuard],
    data: { viewMode: 'manager-evaluation' },
  },
  {
    path: 'manager/training/:id',
    loadChildren: () => import('./pages/manager/training/training.module').then((m) => m.TrainingPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['manager'] },
  },
  {
    path: ':role/messenger/:trainingId/:type/:id',
    loadChildren: () => import('./pages/messenger/messenger.page.module').then((m) => m.MessengerPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['manager', 'tutor', 'apprentice'] },
  },
  {
    // Path to special 'pedago' groupe between one apprentice / one tutor and the managers
    // e.g. : /manager/messenger/55sa31FIrxjToRWOnML0/group/MBgOCghu60j5ZLYsYstG/rwoGEeWmF3EOt2o6EzzOQxxcHrk0/4CM3IxJ3ZxWi0SKqn6I5
    path: ':role/messenger/:trainingId/:type/:id/:apprenticeId/:tutorId',
    loadChildren: () => import('./pages/messenger/messenger.page.module').then((m) => m.MessengerPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['manager', 'tutor', 'apprentice'] },
  },
  {
    path: 'apprentice/home',
    loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
    data: { roles: ['apprentice'] },
  },
  {
    path: 'apprentice/documents/:trainingId',
    loadChildren: () => import('./pages/apprentice/documents/documents.module').then((m) => m.DocumentsPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['apprentice'] },
  },
  {
    path: 'alumni/home',
    loadChildren: () => import('./pages/alumni/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
    data: { roles: ['alumni', 'manager'] },
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['apprentice', 'tutor', 'manager'] },
  },
  {
    path: 'avatar',
    loadChildren: () => import('./pages/avatar/avatar.module').then((m) => m.AvatarPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['manager', 'tutor', 'apprentice'] },
  },
  {
    path: ':role/avatar',
    loadChildren: () => import('./pages/avatar/avatar.module').then((m) => m.AvatarPageModule),
    canActivate: [AuthGuard],
    data: { roles: ['manager', 'tutor', 'apprentice'] },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
